import HeroSection from './components/HeroSection';
import FeaturedGames from './components/FeaturedGames';
import CategoryGrid from './components/CategoryGrid';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <main>
      <HeroSection />
      <FeaturedGames />
      <CategoryGrid />
      <LatestArticles />
      <FAQSection />
      <CTASection />
    </main>
  );
}